export const DynamicWebsiteFilterMap = {
    USER_WEBSITE: 'landing_page',
    EMPTY_ID: '0'
}

export const DynamicWebsiteFilterMixin = {
    data() {
        return {
            DynamicWebsiteFilters: DynamicWebsiteFilterMap
        };
    }
}